export default class PublicacaoDetailsController {
  constructor($q, $state, $scope, AuthenticationService, AuthorizationService, UIService, PublicacaoService, Publicacao, PublicacaoAutor, PublicacaoTipo, PublicacaoAreaInterdisciplinar, PublicacaoGrupoInvestigacao, Ranking, Investigador, AreaInterdisciplinar, GrupoInvestigacao, Impacto, ImpactoOds, Ods, Pais, InvestigadorTooltip, Revista) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.AuthorizationService = AuthorizationService;
    this.PublicacaoService = PublicacaoService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Publicacao = Publicacao;
    this.PublicacaoAutor = PublicacaoAutor;
    this.PublicacaoTipo = PublicacaoTipo;
    this.PublicacaoAreaInterdisciplinar = PublicacaoAreaInterdisciplinar;
    this.PublicacaoGrupoInvestigacao = PublicacaoGrupoInvestigacao;
    this.Ranking = Ranking;
    this.Investigador = Investigador;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.GrupoInvestigacao = GrupoInvestigacao;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.InvestigadorTooltip = InvestigadorTooltip;
    this.Revista = Revista;
    this.showEstadosPanel = false;

    this.loaded = false;

    this.elementosOptions = {
      containment: 'parent',
      tolerance: 'pointer',
      handle: '.pmd-move-handle',
      'ui-floating': true,
      stop: (e, ui) => {
        let tasks = [];
        for (let i in this.elementos) {
          let defer = this.$q.defer();
          this.elementos[i].ordem = Number(i) + 1;
          this.elementos[i].atualizadoa = moment().format();
          this.elementos[i].atualizadoPorId = this.user.id;
          this.PublicacaoAutor.upsert(this.elementos[i]).$promise.then(() => {
            defer.resolve(i);
          }).catch(() => defer.reject(i));
          tasks.push(defer.promise);
        }
        this.$q.all(tasks).then(() => {
          this.getElementosForPublicacao();
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Erro de reordenação. Recarregue a página,")
        });
      }
    };

    // Default opt state - populate later when we have all states
    this.optElemento = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "ordem",
      sort: "asc",
      filter: {},
      filterLayout: {}
    };
    this.elementos = null;
    this.elementosLoading = true;

    // Default opt state - populate later when we have all states
    this.optAreas = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.areas = null;
    this.areasLoading = true;

    // Default opt state - populate later when we have all states
    this.optGrupoInvestigacao = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.gruposInvestigacao = null;
    this.gruposInvestigacaoLoading = true;

    // Default opt state - populate later when we have all states
    this.optImpactosOds = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.impactosOds = null;
    this.impactosOdsLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  displayDataPublicacao = () => {
    let output = '';
    if (this.data) { // It's already loaded
      if (this.data.dia && this.data.mes) {
        output = `${this.data.dia}/${this.data.mes}/${this.data.ano}`;
      } else {
        if (this.data.mes) {
          output = `${this.data.mes}/${this.data.ano}`;
        } else {
          output = this.data.ano;
        }
      }
    }
    return output;
  };

  loadData = () => {
    this.loaded = false;
    if (this.id) {
      this.Publicacao.findOne({
        filter: {
          where: {
            id: this.id
          },
          include: ['criadoPor', 'atualizadoPor', 'tipo', 'impacto', 'revista', {
            relation: 'autores',
            scope: {
              include: {
                relation: 'investigador',
                scope: {
                  fields: {userId: true}
                }
              }
            }
          }]
        }
      }).$promise.then(res => {
        this.data = res;

        this.getImpactosOdsForImpacto(); // We can only load this after getting impactoId
        this.getElementosForPublicacao();
        this.getAreasForPublicacao();
        this.getGruposInvestigacaoForPublicacao();
        this.getTooltips();

        this.loaded = true;
      }).catch((error) => {
        console.log(error);
        this.$state.go('app.publicacao.list');
        this.UI.addToast('Erro ao carregar Publicação. Verifique a ligação');
      });
    } else {
      this.$state.go('app.publicacao.list');
    }
  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Revista.find({
      filter: {
        fields: {id: true, nome: true, issn: true, issnOnline: true}
      }
    }).$promise.then(revistas => {
      revistas.sort((a, b) => a.nome.localeCompare(b.nome));
      this.PublicacaoTipo.find({}).$promise.then(tipos => {
        this.Ranking.find({}).$promise.then(rankings => {
          wait.close();
          let options = {
            size: 'lg',
            template: require('./details.dialog.html'),
            controller: ['$scope', '$dialog', ($scope, $dialog) => {
              $scope.label = "Editar Publicação";
              $scope.AuthorizationService = this.AuthorizationService;
              $scope.rankingTooltip = this.tooltips.find(x => x.id === 11); // Ranking Journal Tooltip
              $scope.publicacao = angular.copy(this.data);
              $scope.tipos = tipos;
              $scope.rankings = rankings;
              $scope.revistas = revistas;
              $scope.simnao = this.simnao;
              $scope.checkingSlug = false;

              $scope.auxTipo = {
                selected: $scope.publicacao.tipo ? $scope.publicacao.tipo : undefined,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              $scope.auxRevista = {
                selected: $scope.publicacao.revista ? $scope.revistas.find(x => x.id === $scope.publicacao.revista.id) : undefined,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              // Attempt to find ranking if not found, add what is filled as option to dropdown
              let foundRanking = undefined;
              if ($scope.publicacao.rankingJournal) {
                foundRanking = rankings.find(x => $scope.publicacao.rankingJournal === x.designacao);
                if (!foundRanking)
                  foundRanking = {id: 0, designacao: $scope.publicacao.rankingJournal};
                rankings.push(angular.copy(foundRanking));
              }

              $scope.auxRanking = {
                selected: foundRanking,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              $scope.auxDestaque = {
                selected: $scope.publicacao.emDestaque ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };

              // Infinite Scroll magic
              $scope.addMoreItems = (infiniteScroll) => {
                infiniteScroll.currentItems += infiniteScroll.numToAdd;
              };

              $scope.updateSlug = () => {
                $scope.publicacao.slug = this.PublicacaoService.stringToSlug($scope.publicacao.titulo);
              };

              $scope.ok = () => {
                if (!this.PublicacaoService.isValidSlug($scope.publicacao.slug)) {
                  this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
                  return;
                }
                // Check if slug exists
                $scope.checkingSlug = true;
                let wait = this.UI.showWaiting();
                this.PublicacaoService.checkExistingSlug($scope.publicacao.slug, this.data.id).then((exists) => {
                  $scope.checkingSlug = false;
                  wait.close();
                  if (exists) {
                    this.UI.addToast("Este slug já existe para outra publicação");
                  } else {
                    $dialog.close($scope);
                  }
                }).catch(err => {
                  $scope.checkingSlug = false;
                  wait.close();
                  this.UI.addToast("Erro de verificação de slug. Verifique a ligação");
                  console.log(err);
                });
              };

              $scope.cancel = () => $scope.$dismiss('cancel');
            }]
          };

          this.UI.showDialog(options).then(res => {
            this.loaded = false;
            if (res) {
              this.data.titulo = res.publicacao.titulo;
              this.data.slug = res.publicacao.slug;
              this.data.tituloSupra = res.publicacao.tituloSupra;
              this.data.repositorio = res.publicacao.repositorio;
              this.data.dia = res.publicacao.dia;
              this.data.mes = res.publicacao.mes;
              this.data.ano = res.publicacao.ano;
              this.data.doiShort = res.publicacao.doiShort;
              this.data.doiWww = res.publicacao.doiWww;
              this.data.isbn = res.publicacao.isbn;

              this.data.emDestaque = res.auxDestaque.selected.value || 0;

              // ISSN not updated, revistaId updated or discarded
              if (res.auxRevista.selected && res.auxRevista.selected.id > 0) {
                if (res.auxRevista.selected.issn) {
                  this.data.issn = res.auxRevista.selected.issn;
                } else {
                  this.data.issn = res.auxRevista.selected.issnOnline;
                }
                this.data.revistaId = res.auxRevista.selected.id;
              }
              else {
                this.data.revistaId = null;
                this.data.issn = null;
              }

              this.data.repositorio = res.publicacao.repositorio;

              this.data.tipo = res.auxTipo.selected;
              this.data.tipoId = res.auxTipo.selected.id;

              // Copy Ranking by value if changed
              if (res.auxRanking.selected && res.auxRanking.selected.id > 0)
                this.data.rankingJournal = res.auxRanking.selected.designacao;

              this.data.atualizadoPorId = this.user.id;
              this.data.atualizadoa = moment().format();

              this.Publicacao.upsert(this.data).$promise.then((res) => {
                this.UI.addToast("Dados atualizados com sucesso");
                // Update Publicacao validity
                this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
                  angular.extend(this.data, data.publicacao);
                  this.loadData();
                }).catch(err => {
                  console.log(err);
                  this.UI.addToast("Não foi possível verificar validade da publicação.");
                  this.loadData();
                });
              }).catch((error) => {
                console.log(error);
                this.UI.showAlert("Erro ao atualizar Publicação. Verifique a ligação");
                this.loaded = true;
              });
            }
          });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Rankings. Verifique a ligação");
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Tipos de Publicação. Verifique a ligação");
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Revistas. Verifique a ligação");
    });
  };

  // Edit yes/no with extra data
  editInformacao = () => {
    let options = {
      size: 'lg',
      template: require('./informacao.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Informação Adicional";
        $scope.publicacao = angular.copy(this.data);
        $scope.simnao = this.simnao;

        $scope.auxScopus = {
          selected: $scope.publicacao.scopus ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxCited = {
          selected: $scope.publicacao.cited ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxOpen = {
          selected: $scope.publicacao.openAccess ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxSpecialIssue = {
          selected: $scope.publicacao.specialIssue ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxDifferent = {
          selected: $scope.publicacao.differentInstitutionsAuthors ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxIndustry = {
          selected: $scope.publicacao.industry ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        this.data.observacoes = res.publicacao.observacoes || null;
        // Update bool values
        this.data.scopus = res.auxScopus.selected.value;
        this.data.cited = res.auxCited.selected.value;
        this.data.openAccess = res.auxOpen.selected.value;
        this.data.specialIssue = res.auxSpecialIssue.selected.value;
        this.data.differentInstitutionsAuthors = res.auxDifferent.selected.value;
        this.data.industry = res.auxIndustry.selected.value;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Publicacao.upsert(this.data).$promise.then((res) => {
          this.UI.addToast("Dados atualizados com sucesso");
          // Update Publicacao validity
          this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
            angular.extend(this.data, data.publicacao);
            this.loadData();
          }).catch(err => {
            console.log(err);
            this.UI.addToast("Não foi possível verificar validade da publicação.");
            this.loadData();
          });
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar publicação. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  // Edit yes/no with extra data
  editQuestoes = () => {
    let options = {
      size: 'lg',
      template: require('./questoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Informação Complementar";
        $scope.publicacao = angular.copy(this.data);
        $scope.simnao = this.simnao;

        $scope.auxInternationalConference = {
          selected: $scope.publicacao.internationalConference ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxCitizen = {
          selected: $scope.publicacao.citizenScienceApproach ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxPerformed = {
          selected: $scope.publicacao.performedPublicConsultation ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxSocialJustice = {
          selected: $scope.publicacao.socialJustice ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxInternational = {
          selected: $scope.publicacao.internationalCollaboration ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxDevelopingCountries = {
          selected: $scope.publicacao.developingCountries ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        // Update bool values
        this.data.internationalConference = res.auxInternationalConference.selected.value;
        this.data.citizenScienceApproach = res.auxCitizen.selected.value;
        this.data.performedPublicConsultation = res.auxPerformed.selected.value;
        this.data.socialJustice = res.auxSocialJustice.selected.value;
        this.data.internationalCollaboration = res.auxInternational.selected.value;
        this.data.developingCountries = res.auxDevelopingCountries.selected.value;
        // Remove text if bool values are false
        if (!this.data.citizenScienceApproach) this.data.citizenScienceApproachText = null;
        else this.data.citizenScienceApproachText = res.publicacao.citizenScienceApproachText;
        if (!this.data.performedPublicConsultation) this.data.performedPublicConsultationText = null;
        else this.data.performedPublicConsultationText = res.publicacao.performedPublicConsultationText;
        if (!this.data.socialJustice) this.data.socialJusticeText = null;
        else this.data.socialJusticeText = res.publicacao.socialJusticeText;
        if (!this.data.internationalCollaboration) this.data.internationalCollaborationText = null;
        else this.data.internationalCollaborationText = res.publicacao.internationalCollaborationText;
        if (!this.data.developingCountries) this.data.developingCountriesText = null;
        else this.data.developingCountriesText = res.publicacao.developingCountriesText;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Publicacao.upsert(this.data).$promise.then((res) => {
          this.UI.addToast("Dados atualizados com sucesso");
          // Update Publicacao validity
          this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
            angular.extend(this.data, data.publicacao);
            this.loadData();
          }).catch(err => {
            console.log(err);
            this.UI.addToast("Não foi possível verificar validade da publicação.");
            this.loadData();
          });
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar Publicação. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  validityInfo = () => {
    let wait = this.UI.showWaiting();
    this.PublicacaoService.validityInfo(this.data.id).then(data => {
      wait.close();
      if (data && data.length > 0) {
        let title = "Publicação - Informação em falta";
        let introText = "A lista seguinte mostra a informação obrigatória necessária";
        let instance = this.UI.showDialog({
          size: 'md',
          template: require('../../interface/modals/show-list.html'),
          controller: ['$scope', ($scope) => {
            $scope.title = title;
            $scope.introText = introText;
            $scope.list = data;
            $scope.ok = function () {
              $scope.$close();
            };
          }]
        });
        instance.finally(() => {
          // Nothing should happen
        });
      } else {
        this.UI.addToast("Publicação válida");
      }
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível obter dados de publicação. Verifique a ligação");
    });
  };

  updatePublicacao = () => {
    this.loaded = false;
    this.Publicacao.updatePublicacao({orcidId: this.data.orcidBaseId, putCode: this.data.putCode}).$promise.then((res) => {
      this.UI.addToast("Publicação atualizada");
      this.loadData();
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro de atualização. Verifique a ligação");
    });
  };

  // Multiple data
  // Elementos - Equipa
  elementoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let elemento = {};
    let auxInvestigadorSelection = undefined;
    if (edit && data != null) {
      elemento = angular.copy(data);
    }
    if (data != null && data.investigador) {
      auxInvestigadorSelection = elemento.investigador;
    }
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.autor.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Autor da Publicação";
          scope.elemento = elemento;
          scope.investigadores = investigadores;
          scope.isInvestigador = scope.elemento.investigador !== undefined;

          scope.auxInvestigador = {
            selected: auxInvestigadorSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Automatically update autorDisplay when investigador is selected
          scope.onInvestigadorSelected = (item) => {
            scope.elemento.autorDisplay = item.nome;
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo elemento para Publicacao
  addElemento = () => {
    this.elementoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.elemento) {
          this.elementosLoading = true;
          let item = angular.copy(ok.elemento);
          item.ordem = this.elementos.length + 1;
          if (ok.isInvestigador && ok.auxInvestigador.selected) { // Is Investigador
            item.autor = undefined;
            item.investigadorId = ok.auxInvestigador.selected.id;
            item.investigador = angular.copy(ok.auxInvestigador.selected);
            // Check if elemento is already there before creating
            this.PublicacaoService.usedPartialDataForModel({
              publicacaoId: this.id,
              investigadorId: item.investigadorId
            }, this.PublicacaoAutor).then(res => {
              if (res.count > 0) { // Already exists
                this.UI.addToast("Autor já existe");
                this.elementosLoading = false;
              } else { // Create it
                this.PublicacaoService.createMultipleData(this.PublicacaoAutor, [item], this.id, 'publicacaoId').then((x) => {
                  this.UI.addToast("Autor adicionado com sucesso");
                  // Update Publicacao validity
                  this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
                    angular.extend(this.data, data.publicacao);
                    this.getElementosForPublicacao();
                  }).catch(err => {
                    console.log(err);
                    this.UI.addToast("Não foi possível verificar validade da publicação.");
                    this.getElementosForPublicacao();
                  });
                }).catch(error => {
                  this.elementosLoading = false;
                  this.UI.addToast("Erro ao inserir autor. Verifique a ligação");
                  console.log(error);
                });
              }
            }).catch((error) => {
              this.elementosLoading = false;
              this.UI.addToast("Erro de criação. Verifique a ligação.");
              console.log(error);
            });
          } else { // Is Other Author, create regular object
            item.id = 0;
            item.publicacaoId = this.data.id;
            item.investigadorId = null;
            item.autorDisplay = item.autor; // Copy display data from autor
            item.criadoPorId = this.user.id;
            item.dataCriacao = moment().format();
            item.atualizadoPorId = this.user.id;
            item.atualizadoa = moment().format();
            this.PublicacaoAutor.create(item).$promise.then((res) => {
              this.UI.addToast("Autor adicionado com sucesso");
              // Update Publicacao validity
              this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
                angular.extend(this.data, data.publicacao);
                this.getElementosForPublicacao();
              }).catch(err => {
                console.log(err);
                this.UI.addToast("Não foi possível verificar validade da publicação.");
                this.getElementosForPublicacao();
              });
            }).catch((error) => {
              console.log(error);
              this.elementosLoading = false;
              this.UI.addToast("Erro de criação. Verifique a ligação.");
            });
          }
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Editar elemento para Publicacao
  editElemento = (x) => {
    this.elementoModalOptions(x, true).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.elemento) {
          this.elementosLoading = true;
          if (ok.isInvestigador && ok.auxInvestigador.selected) { // Is Investigador
            x.investigadorId = ok.auxInvestigador.selected.id;
            x.investigador = angular.copy(ok.auxInvestigador.selected);
            x.autor = null;
            x.autorDisplay = ok.elemento.autorDisplay;

            x.atualizadoPorId = this.user.id;
            x.atualizadoa = moment().format();

            // Check if elemento is already there before creating
            this.PublicacaoService.usedPartialDataForModel({
              publicacaoId: this.id,
              investigadorId: x.investigadorId
            }, this.PublicacaoAutor).then(res => {
              if (res.count > 0) { // Already exists? Check if it's the exact same id (edit) or new one
                this.PublicacaoAutor.findOne({
                  filter: {
                    fields: {id: true},
                    where: {
                      publicacaoId: this.id,
                      investigadorId: x.investigadorId
                    }
                  }
                }).$promise.then((foundAutor) => {
                  if (foundAutor.id !== x.id) { // It's a different author that already exists, refuse
                    this.UI.addToast("Autor já existe");
                    this.getElementosForPublicacao();
                  } else { // It's the same author, upsert so it changes autorDisplay (if changed)
                    this.PublicacaoAutor.upsert(x).$promise.then(() => {
                      this.UI.addToast("Autor editado com sucesso");
                      // Update Publicacao validity
                      this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
                        angular.extend(this.data, data.publicacao);
                        this.getElementosForPublicacao();
                      }).catch(err => {
                        console.log(err);
                        this.UI.addToast("Não foi possível verificar validade da publicação.");
                        this.getElementosForPublicacao();
                      });
                    }).catch(error => {
                      this.elementosLoading = false;
                      this.UI.addToast("Erro ao inserir autor. Verifique a ligação");
                      console.log(error);
                    });
                  }
                }).catch((error) => {
                  this.elementosLoading = false;
                  this.UI.addToast("Erro ao inserir autor. Verifique a ligação");
                  console.log(error);
                });
              } else { // Create it
                this.PublicacaoAutor.upsert(x).$promise.then(() => {
                  this.UI.addToast("Autor editado com sucesso");
                  // Update Publicacao validity
                  this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
                    angular.extend(this.data, data.publicacao);
                    this.getElementosForPublicacao();
                  }).catch(err => {
                    console.log(err);
                    this.UI.addToast("Não foi possível verificar validade da publicação.");
                    this.getElementosForPublicacao();
                  });
                }).catch(error => {
                  this.elementosLoading = false;
                  this.UI.addToast("Erro ao inserir autor. Verifique a ligação");
                  console.log(error);
                });
              }
            }).catch((error) => {
              this.elementosLoading = false;
              this.UI.addToast("Erro de criação. Verifique a ligação.");
              console.log(error);
            });
          } else { // Is Other Author
            delete x.investigador;
            x.investigadorId = null;
            x.autor = ok.elemento.autor;
            x.autorDisplay = ok.elemento.autor;

            x.atualizadoPorId = this.user.id;
            x.atualizadoa = moment().format();

            this.PublicacaoAutor.upsert(x).$promise.then(() => {
              this.UI.addToast("Autor editado com sucesso");
              // Update Publicacao validity
              this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
                angular.extend(this.data, data.publicacao);
                this.getElementosForPublicacao();
              }).catch(err => {
                console.log(err);
                this.UI.addToast("Não foi possível verificar validade da publicação.");
                this.getElementosForPublicacao();
              });
            }).catch(error => {
              this.elementosLoading = false;
              this.UI.addToast("Erro ao inserir autor. Verifique a ligação");
              console.log(error);
            });
          }
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete elemento
  confirmDeleteElemento = (x) => {
    let title = "Remover Membro da Equipa";
    let warning = "Tem a certeza que pretende remover este autor?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeElemento(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeElemento = (x) => {
    this.elementosLoading = true;
    // Find again elemento to delete so we can update it
    this.PublicacaoAutor.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((elementoToRemove) => {

      // Remove data
      this.PublicacaoAutor.deleteById({
        id: elementoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Autor removido com sucesso");
        // Update Publicacao validity
        this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
          angular.extend(this.data, data.publicacao);
          this.getElementosForPublicacao();
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Não foi possível verificar validade da publicação.");
          this.getElementosForPublicacao();
        });
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar autor. Verifique se ainda existe.");
      this.getElementosForPublicacao();
    });
  };

  getElementosForPublicacao = () => {
    this.elementosLoading = true;
    let whereLiteral = {
      'PublicacaoAutor.publicacaoId': this.id
    };
    let where = {};
    Object.keys(this.optElemento.filter).forEach(f => {
      if (this.optElemento.filter[f])
        where[f] = this.optElemento.filter[f];
    });
    this.PublicacaoAutor.table({
      params: {
        fields: [
          'PublicacaoAutor.id as id',
          'PublicacaoAutor.publicacaoId as publicacaoId',
          'PublicacaoAutor.investigadorId as investigadorId',
          'PublicacaoAutor.dataCriacao as dataCriacao',
          'PublicacaoAutor.atualizadoa as atualizadoa',
          'PublicacaoAutor.autor as autor',
          'PublicacaoAutor.autorDisplay as autorDisplay',
          'PublicacaoAutor.ordem as ordem',
          'PublicacaoAutor.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Investigador.id as auxInvestigadorId',
          'Investigador.nome as auxInvestigadorNome'
        ],
        from: ['PublicacaoAutor', 'User', 'User', 'Investigador'],
        references: [undefined, 'PublicacaoAutor.criadoPorId', 'PublicacaoAutor.atualizadoPorId', 'PublicacaoAutor.investigadorId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optElemento.order,
        sort: this.optElemento.sort,
        limit: this.optElemento.items,
        skip: (this.optElemento.page - 1) * this.optElemento.items,
      }
    }).$promise.then(res => {
      let page = this.optElemento.page;
      let items = this.optElemento.items;

      let total = res.count;

      this.optElemento.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optElemento.start - 1 + items) >= total) {
        this.optElemento.end = total;
      } else {
        this.optElemento.end = Number.parseInt(this.optElemento.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        if (x.auxInvestigadorId) {
          x.investigador = {
            id: x.auxInvestigadorId,
            nome: x.auxInvestigadorNome,
            ordem: x.ordem
          };
        }
      });

      this.elementos = res.data;
      this.optElemento.total = total;
      this.elementosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler autores de publicação. Verifique a ligação");
    });
  };

  elementoSort = keyname => {
    if (this.optElemento.order === keyname)
      this.optElemento.page = 1;
    this.optElemento.order = keyname;
    this.optElemento.sort = this.optElemento.sort === 'asc' ? 'desc' : 'asc';
    this.getElementosForPublicacao();
  };

  elementoItem = val => {
    this.optElemento.items = val;
    this.optElemento.page = 1;
    this.getElementosForPublicacao();
  };

  elementoPage = sum => {
    this.optElemento.page += sum;
    if (this.optElemento.page < 1)
      this.optElemento.page = 1;
    if (this.optElemento.page > Math.ceil(this.optElemento.total / this.optElemento.items))
      this.optElemento.page = Math.ceil(this.optElemento.total / this.optElemento.items);
    this.getElementosForPublicacao();
  };

  viewElemento = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./elemento.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Área Interdisciplinar
  areasModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let area = {};
    let auxAreaSelection = undefined;
    if (edit && data != null) {
      area = angular.copy(data);
      auxAreaSelection = area.area;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.area.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Área Interdisciplinar";
          scope.area = area;
          scope.areas = areas;

          scope.auxArea = {
            selected: auxAreaSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas interdisciplinares. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova área para Publicacao
  addArea = () => {
    if (this.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    this.areasModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          this.areasLoading = true;
          let item = angular.copy(ok.area);
          item.areaId = ok.auxArea.selected.id;
          item.area = angular.copy(ok.auxArea.selected);
          // Check if area is already there before creating
          this.PublicacaoService.usedPartialDataForModel({publicacaoId: this.id, areaId: item.areaId}, this.PublicacaoAreaInterdisciplinar).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Área Interdisciplinar já existe");
              this.areasLoading = false;
            } else { // Create it
              this.PublicacaoService.createMultipleData(this.PublicacaoAreaInterdisciplinar, [item], this.id, 'publicacaoId').then((x) => {
                this.UI.addToast("Área Interdisciplinar adicionada com sucesso");
                // Update Publicacao validity
                this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
                  angular.extend(this.data, data.publicacao);
                  this.getAreasForPublicacao();
                }).catch(err => {
                  console.log(err);
                  this.UI.addToast("Não foi possível verificar validade da publicação.");
                  this.getAreasForPublicacao();
                });
              }).catch(error => {
                this.areasLoading = false;
                this.UI.addToast("Erro ao inserir área. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.areasLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteArea = (x) => {
    let title = "Eliminar Área Interdisciplinar";
    let warning = "Tem a certeza que pretende remover esta área interdisciplinar?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeArea(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeArea = (x) => {
    this.areasLoading = true;
    // Find again area to delete so we can update it
    this.PublicacaoAreaInterdisciplinar.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((areaToRemove) => {
      // Only for mandatory existing multiple data
      this.PublicacaoAreaInterdisciplinar.count({
        fields: {id: true},
        where: {
          publicacaoId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other areas still remaining

          // Remove data
          this.PublicacaoAreaInterdisciplinar.deleteById({
            id: areaToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Área interdisciplinar removida com sucesso");
            // Update Publicacao validity
            this.Publicacao.checkValido({publicacaoId: this.data.id}).$promise.then(data => {
              angular.extend(this.data, data.publicacao);
              this.getAreasForPublicacao();
            }).catch(err => {
              console.log(err);
              this.UI.addToast("Não foi possível verificar validade da publicação.");
              this.getAreasForPublicacao();
            });
          });

        } else { // No other areas exist, can't remove
          this.areasLoading = false;
          this.UI.showAlert("Não foi possível apagar a área interdisciplinar porque tem que haver pelo menos 1 registo para a Publicação");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar Publicação. Verifique a ligação");
        this.getAreasForPublicacao();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar área interdisciplinar. Verifique se ainda existe.");
      this.getAreasForPublicacao();
    });
  };

  getAreasForPublicacao = () => {
    this.areasLoading = true;
    let whereLiteral = {
      'PublicacaoAreaInterdisciplinar.publicacaoId': this.id
    };
    let where = {};
    Object.keys(this.optAreas.filter).forEach(f => {
      if (this.optAreas.filter[f])
        where[f] = this.optAreas.filter[f];
    });
    this.PublicacaoAreaInterdisciplinar.table({
      params: {
        fields: [
          'PublicacaoAreaInterdisciplinar.id as id',
          'PublicacaoAreaInterdisciplinar.publicacaoId as publicacaoId',
          'PublicacaoAreaInterdisciplinar.areaId as areaId',
          'PublicacaoAreaInterdisciplinar.dataCriacao as dataCriacao',
          'PublicacaoAreaInterdisciplinar.atualizadoa as atualizadoa',
          'PublicacaoAreaInterdisciplinar.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'AreaInterdisciplinar.id as auxAreaId',
          'AreaInterdisciplinar.designacao as auxAreaDesignacao'
        ],
        from: ['PublicacaoAreaInterdisciplinar', 'User', 'User', 'AreaInterdisciplinar'],
        references: [undefined, 'PublicacaoAreaInterdisciplinar.criadoPorId', 'PublicacaoAreaInterdisciplinar.atualizadoPorId', 'PublicacaoAreaInterdisciplinar.areaId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optAreas.order,
        sort: this.optAreas.sort,
        limit: this.optAreas.items,
        skip: (this.optAreas.page - 1) * this.optAreas.items,
      }
    }).$promise.then(res => {
      let page = this.optAreas.page;
      let items = this.optAreas.items;

      let total = res.count;

      this.optAreas.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optAreas.start - 1 + items) >= total) {
        this.optAreas.end = total;
      } else {
        this.optAreas.end = Number.parseInt(this.optAreas.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.area = {
          id: x.auxAreaId,
          designacao: x.auxAreaDesignacao
        };
      });

      this.areas = res.data;
      this.optAreas.total = total;
      this.areasLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler áreas. Verifique a ligação");
    });
  };

  areaSort = keyname => {
    if (this.optAreas.order === keyname)
      this.optAreas.page = 1;
    this.optAreas.order = keyname;
    this.optAreas.sort = this.optAreas.sort === 'asc' ? 'desc' : 'asc';
    this.getAreasForPublicacao();
  };

  areaItem = val => {
    this.optAreas.items = val;
    this.optAreas.page = 1;
    this.getAreasForPublicacao();
  };

  areaPage = sum => {
    this.optAreas.page += sum;
    if (this.optAreas.page < 1)
      this.optAreas.page = 1;
    if (this.optAreas.page > Math.ceil(this.optAreas.total / this.optAreas.items))
      this.optAreas.page = Math.ceil(this.optAreas.total / this.optAreas.items);
    this.getAreasForPublicacao();
  };

  viewArea = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./area.interdisciplinar.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Grupos de Investigação
  grupoInvestigacaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let grupo = {};
    let auxGrupoInvestigacaoSelection = undefined;
    if (edit && data != null) {
      grupo = angular.copy(data);
      auxGrupoInvestigacaoSelection = grupo.grupo;
    }
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((gruposInvestigacao) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.grupo.investigacao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Adicionar") + " Grupo de Investigação";
          scope.grupo = grupo;
          scope.grupos = gruposInvestigacao;

          scope.auxGrupoInvestigacao = {
            selected: auxGrupoInvestigacaoSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo grupo de investigação para publicação
  addGrupoInvestigacao = () => {
    this.grupoInvestigacaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupo) {
          this.gruposInvestigacaoLoading = true;
          let item = angular.copy(ok.grupo);
          item.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          item.grupo = angular.copy(ok.auxGrupoInvestigacao.selected);
          // Check if grupo investigacao is already there before creating
          this.PublicacaoService.usedPartialDataForModel({publicacaoId: this.id, grupoInvestigacaoId: item.grupoInvestigacaoId}, this.PublicacaoGrupoInvestigacao).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Grupo de Investigação já existe");
              this.gruposInvestigacaoLoading = false;
            } else { // Create it
              this.PublicacaoService.createMultipleData(this.PublicacaoGrupoInvestigacao, [item], this.id, 'publicacaoId').then((x) => {
                this.UI.addToast("Grupo de investigação adicionado com sucesso");
                this.getGruposInvestigacaoForPublicacao();
              }).catch(error => {
                this.gruposInvestigacaoLoading = false;
                this.UI.addToast("Erro ao inserir grupo de investigação. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.gruposInvestigacaoLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete grupo investigação
  confirmDeleteGrupoInvestigacao = (x) => {
    let title = "Eliminar Grupo de Investigação";
    let warning = "Tem a certeza que pretende remover a associação ao grupo de investigação?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeGrupoInvestigacao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeGrupoInvestigacao = (x) => {
    this.gruposInvestigacaoLoading = true;
    // Find again grupo investigação to delete so we can update it
    this.PublicacaoGrupoInvestigacao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((grupoInvestigacaoToRemove) => {

      // Remove data
      this.PublicacaoGrupoInvestigacao.deleteById({
        id: grupoInvestigacaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Grupo de Investigação removido com sucesso");
        this.getGruposInvestigacaoForPublicacao();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar grupo. Verifique se ainda existe.");
      this.getGruposInvestigacaoForPublicacao();
    });
  };

  getGruposInvestigacaoForPublicacao = () => {
    this.gruposInvestigacaoLoading = true;
    let whereLiteral = {
      'PublicacaoGrupoInvestigacao.publicacaoId': this.id
    };
    let where = {};
    Object.keys(this.optGrupoInvestigacao.filter).forEach(f => {
      if (this.optGrupoInvestigacao.filter[f])
        where[f] = this.optGrupoInvestigacao.filter[f];
    });
    this.PublicacaoGrupoInvestigacao.table({
      params: {
        fields: [
          'PublicacaoGrupoInvestigacao.id as id',
          'PublicacaoGrupoInvestigacao.publicacaoId as publicacaoId',
          'PublicacaoGrupoInvestigacao.grupoInvestigacaoId as grupoInvestigacaoId',
          'PublicacaoGrupoInvestigacao.dataCriacao as dataCriacao',
          'PublicacaoGrupoInvestigacao.atualizadoa as atualizadoa',
          'PublicacaoGrupoInvestigacao.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'GrupoInvestigacao.id as auxGrupoInvestigacaoId',
          'GrupoInvestigacao.designacao as auxGrupoInvestigacaoDesignacao',
          'GrupoInvestigacao.descricao as auxGrupoInvestigacaoDescricao',
        ],
        from: ['PublicacaoGrupoInvestigacao', 'User', 'User', 'GrupoInvestigacao'],
        referencesOrigin: [undefined, undefined, undefined, undefined],
        references: [undefined, 'PublicacaoGrupoInvestigacao.criadoPorId', 'PublicacaoGrupoInvestigacao.atualizadoPorId', 'PublicacaoGrupoInvestigacao.grupoInvestigacaoId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optGrupoInvestigacao.order,
        sort: this.optGrupoInvestigacao.sort,
        limit: this.optGrupoInvestigacao.items,
        skip: (this.optGrupoInvestigacao.page - 1) * this.optGrupoInvestigacao.items,
      }
    }).$promise.then(res => {
      let page = this.optGrupoInvestigacao.page;
      let items = this.optGrupoInvestigacao.items;

      let total = res.count;

      this.optGrupoInvestigacao.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optGrupoInvestigacao.start - 1 + items) >= total) {
        this.optGrupoInvestigacao.end = total;
      } else {
        this.optGrupoInvestigacao.end = Number.parseInt(this.optGrupoInvestigacao.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.grupo = {
          id: x.auxGrupoInvestigacaoId,
          designacao: x.auxGrupoInvestigacaoDesignacao,
          descricao: x.auxGrupoInvestigacaoDescricao
        };
      });

      this.gruposInvestigacao = res.data;
      this.optGrupoInvestigacao.total = total;
      this.gruposInvestigacaoLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a ligação");
    });
  };

  grupoInvestigacaoSort = keyname => {
    if (this.optGrupoInvestigacao.order === keyname)
      this.optGrupoInvestigacao.page = 1;
    this.optGrupoInvestigacao.order = keyname;
    this.optGrupoInvestigacao.sort = this.optGrupoInvestigacao.sort === 'asc' ? 'desc' : 'asc';
    this.getGruposInvestigacaoForPublicacao();
  };

  grupoInvestigacaoItem = val => {
    this.optGrupoInvestigacao.items = val;
    this.optGrupoInvestigacao.page = 1;
    this.getGruposInvestigacaoForPublicacao();
  };

  grupoInvestigacaoPage = sum => {
    this.optGrupoInvestigacao.page += sum;
    if (this.optGrupoInvestigacao.page < 1)
      this.optGrupoInvestigacao.page = 1;
    if (this.optGrupoInvestigacao.page > Math.ceil(this.optGrupoInvestigacao.total / this.optGrupoInvestigacao.items))
      this.optGrupoInvestigacao.page = Math.ceil(this.optGrupoInvestigacao.total / this.optGrupoInvestigacao.items);
    this.getGruposInvestigacaoForPublicacao();
  };

  viewGrupoInvestigacao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./grupo.investigacao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Impactos
  // Edit Impacto Ambiental, Económico, Social
  editImpactos = () => {
    let options = {
      size: 'lg',
      template: require('./impactos.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Impacto Ambiental, Económico, Social";
        $scope.impacto = angular.copy(this.data.impacto);
        $scope.simnao = this.simnao;

        $scope.auxImpactoAmbiental = {
          selected: $scope.impacto.ambiental ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoEconomico = {
          selected: $scope.impacto.economico ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoSocial = {
          selected: $scope.impacto.social ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoPolicyInfluence = {
          selected: $scope.impacto.policyInfluence ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;

      // Ambiental
      if (ok.auxImpactoAmbiental.selected.value) {
        this.data.impacto.ambiental = ok.impacto.ambiental;
      } else {
        this.data.impacto.ambiental = null;
      }
      // Económico
      if (ok.auxImpactoEconomico.selected.value) {
        this.data.impacto.economico = ok.impacto.economico;
      } else {
        this.data.impacto.economico = null;
      }
      // Social
      if (ok.auxImpactoSocial.selected.value) {
        this.data.impacto.social = ok.impacto.social;
      } else {
        this.data.impacto.social = null;
      }
      // Policy influence
      if (ok.auxImpactoPolicyInfluence.selected.value) {
        this.data.impacto.policyInfluence = ok.impacto.policyInfluence;
      } else {
        this.data.impacto.policyInfluence = null;
      }

      this.data.impacto.observacoes = ok.impacto.observacoes || null;

      this.data.impacto.criadoPorId = this.user.id;
      this.data.impacto.dataCriacao = moment().format();

      this.Impacto.upsert(this.data.impacto).$promise.then(() => {
        this.UI.addToast("Impactos atualizados com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar impactos. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  //Impactos ODS
  impactosOdsModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let ods = {};
    let auxOdsSelection = undefined;
    if (edit && data != null) {
      ods = angular.copy(data);
      auxOdsSelection = ods.ods;
    }
    let wait = this.UI.showWaiting();
    this.Ods.find({}).$promise.then((externalData) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/impacto.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Impacto ODS";
          scope.ods = ods;
          scope.externalData = externalData;
          scope.tipo = 'ODS';

          scope.auxOds = {
            selected: auxOdsSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Impactos ODS. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo ODS para impacto
  addImpactoOds = () => {
    this.impactosOdsModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxOds && ok.ods) {
          this.impactosOdsLoading = true;
          let item = angular.copy(ok.ods);
          item.odsId = ok.auxOds.selected.id;
          item.ods = angular.copy(ok.auxOds.selected);
          // Check if ODS is already there before creating
          this.PublicacaoService.usedPartialDataForModel({impactoId: this.data.impactoId, odsId: item.odsId}, this.ImpactoOds).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Impacto ODS já existe");
              this.impactosOdsLoading = false;
            } else { // Create it
              this.PublicacaoService.createMultipleData(this.ImpactoOds, [item], this.data.impactoId, 'impactoId').then(() => {
                this.UI.addToast("ODS adicionado com sucesso");
                this.getImpactosOdsForImpacto();
              }).catch(error => {
                this.impactosOdsLoading = false;
                this.UI.addToast("Erro ao inserir ODS. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.impactosOdsLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete ODS
  confirmDeleteImpactoOds = (x) => {
    let title = "Eliminar Impacto ODS";
    let warning = "Tem a certeza que pretende remover este impacto ODS?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeImpactoOds(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeImpactoOds = (x) => {
    this.impactosOdsLoading = true;
    // Find again impacto ods to delete, so we can update it
    this.ImpactoOds.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((impactoOdsToRemove) => {
      // Only for mandatory existing multiple data

      // Remove data
      this.ImpactoOds.deleteById({
        id: impactoOdsToRemove.id,
      }).$promise.then(() => {
        this.UI.addToast("Impacto ODS removido com sucesso");
        this.getImpactosOdsForImpacto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar impacto ODS. Verifique se ainda existe.");
      this.getImpactosOdsForImpacto();
    });
  };

  getImpactosOdsForImpacto = () => {
    this.impactosOdsLoading = true;
    let whereLiteral = {
      'ImpactoOds.impactoId': this.data.impactoId
    };
    let where = {};
    Object.keys(this.optImpactosOds.filter).forEach(f => {
      if (this.optImpactosOds.filter[f])
        where[f] = this.optImpactosOds.filter[f];
    });
    this.ImpactoOds.table({
      params: {
        fields: [
          'ImpactoOds.id as id',
          'ImpactoOds.impactoId as impactoId',
          'ImpactoOds.odsId as odsId',
          'ImpactoOds.dataCriacao as dataCriacao',
          'User.name as criadoPor',
          'Ods.id as auxOdsId',
          'Ods.designacao as auxOdsDesignacao'
        ],
        from: ['ImpactoOds', 'User', 'Ods'],
        references: [undefined, 'ImpactoOds.criadoPorId', 'ImpactoOds.odsId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optImpactosOds.order,
        sort: this.optImpactosOds.sort,
        limit: this.optImpactosOds.items,
        skip: (this.optImpactosOds.page - 1) * this.optImpactosOds.items,
      }
    }).$promise.then(res => {
      let page = this.optImpactosOds.page;
      let items = this.optImpactosOds.items;

      let total = res.count;

      this.optImpactosOds.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optImpactosOds.start - 1 + items) >= total) {
        this.optImpactosOds.end = total;
      } else {
        this.optImpactosOds.end = Number.parseInt(this.optImpactosOds.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.ods = {
          id: x.auxOdsId,
          designacao: x.auxOdsDesignacao
        };
      });

      this.impactosOds = res.data;
      this.optImpactosOds.total = total;
      this.impactosOdsLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler ODS. Verifique a ligação");
    });
  };

  impactoOdsSort = keyname => {
    if (this.optImpactosOds.order === keyname)
      this.optImpactosOds.page = 1;
    this.optImpactosOds.order = keyname;
    this.optImpactosOds.sort = this.optImpactosOds.sort === 'asc' ? 'desc' : 'asc';
    this.getImpactosOdsForImpacto();
  };

  impactoOdsItem = val => {
    this.optImpactosOds.items = val;
    this.optImpactosOds.page = 1;
    this.getImpactosOdsForImpacto();
  };

  impactoOdsPage = sum => {
    this.optImpactosOds.page += sum;
    if (this.optImpactosOds.page < 1)
      this.optImpactosOds.page = 1;
    if (this.optImpactosOds.page > Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items))
      this.optImpactosOds.page = Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items);
    this.getImpactosOdsForImpacto();
  };

  viewImpactoOds = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./impacto.ods.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss');
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Get all tooltips (so it doesn't fetch all the time)
  getTooltips = () => {
    this.InvestigadorTooltip.find({}).$promise.then((tooltips) => {
      this.tooltips = tooltips;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro na obtenção de ajuda. Não poderá consultar ajudas ao preenchimento. Verifique a ligação");
    });
  };

  showInfo = (id) => {
    let tooltip = this.tooltips.find(x => x.id === id);

    if (!tooltip) {
      this.UI.addToast("Ajuda não encontrada");
      return;
    }

    let options = {
      size: 'md',
      template: require('./info.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.title = tooltip.tag;
        scope.message = tooltip.message;

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };

    let modal = this.UI.showDialog(options);

    modal.then(() => {}).catch(() => {}); // Do nothing
  };


  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canRefreshORCID = () => this.PublicacaoService.canEdit('publicacaoRefreshORCID', true, 'publicacaoRefreshORCIDAny', this.PublicacaoService.getAutoresUserId(this.data));

  canReadGeneral = () => this.PublicacaoService.canRead('publicacaoRead', true, 'publicacaoReadAny', this.PublicacaoService.getAutoresUserId(this.data));
  canEditGeneral = () => this.PublicacaoService.canEdit('publicacaoEdit', true, 'publicacaoEditAny', this.PublicacaoService.getAutoresUserId(this.data));

  canReadAdicional = () => this.PublicacaoService.canRead('publicacaoReadAdicional', true, 'publicacaoReadAdicionalAny', this.PublicacaoService.getAutoresUserId(this.data));
  canEditAdicional = () => this.PublicacaoService.canEdit('publicacaoEditAdicional', true, 'publicacaoEditAdicionalAny', this.PublicacaoService.getAutoresUserId(this.data));

  canReadAutor = () => this.PublicacaoService.canRead('publicacaoReadAutor', true, 'publicacaoReadAutorAny', this.PublicacaoService.getAutoresUserId(this.data));
  canEditAutor = () => this.PublicacaoService.canEdit('publicacaoEditAutor', true, 'publicacaoEditAutorAny', this.PublicacaoService.getAutoresUserId(this.data));

  canReadComplementar = () => this.PublicacaoService.canRead('publicacaoReadComplementar', true, 'publicacaoReadComplementarAny', this.PublicacaoService.getAutoresUserId(this.data));
  canEditComplementar = () => this.PublicacaoService.canEdit('publicacaoEditComplementar', true, 'publicacaoEditComplementarAny', this.PublicacaoService.getAutoresUserId(this.data));

  canReadAreaInterdisciplinar = () => this.PublicacaoService.canRead('publicacaoReadAreaInterdisciplinar', true, 'publicacaoReadAreaInterdisciplinarAny', this.PublicacaoService.getAutoresUserId(this.data));
  canEditAreaInterdisciplinar = () => this.PublicacaoService.canEdit('publicacaoEditAreaInterdisciplinar', true, 'publicacaoEditAreaInterdisciplinarAny', this.PublicacaoService.getAutoresUserId(this.data));

  canReadGrupoInvestigacao = () => this.PublicacaoService.canRead('publicacaoReadGrupoInvestigacao', true, 'publicacaoReadGrupoInvestigacaoAny', this.PublicacaoService.getAutoresUserId(this.data));
  canEditGrupoInvestigacao = () => this.PublicacaoService.canEdit('publicacaoEditGrupoInvestigacao', true, 'publicacaoEditGrupoInvestigacaoAny', this.PublicacaoService.getAutoresUserId(this.data));

  canReadImpacto = () => this.PublicacaoService.canRead('publicacaoReadImpacto', true, 'publicacaoReadImpactoAny', this.PublicacaoService.getAutoresUserId(this.data));
  canEditImpacto = () => this.PublicacaoService.canEdit('publicacaoEditImpacto', true, 'publicacaoEditImpactoAny', this.PublicacaoService.getAutoresUserId(this.data));

}

PublicacaoDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'AuthorizationService', 'UIService', 'PublicacaoService', 'Publicacao', 'PublicacaoAutor', 'PublicacaoTipo', 'PublicacaoAreaInterdisciplinar', 'PublicacaoGrupoInvestigacao', 'Ranking', 'Investigador', 'AreaInterdisciplinar', 'GrupoInvestigacao', 'Impacto', 'ImpactoOds', 'Ods', 'Pais', 'InvestigadorTooltip', 'Revista'];
